export default function FormAssetListController($rootScope, $scope, $uibModal) {
  'ngInject';

  let flag = false;

  $scope.numSelectedAssets = function() {
    if (!$scope.param._selected || !$scope.param) return 0;

    return Object.keys($scope.param._selected).length;
  };

  $scope.selectedAssets = function() {
    return $scope.param._selected;
  };

  function processPreFilter(input) {
    let prefilter = {};
    if (typeof input === 'string') {
      let unescaped = (input || '').replace(/\\/g, '"');
      prefilter = JSON.parse(unescaped);
    } else if (typeof input === 'object') {
      prefilter = input;
    }

    return prefilter;
  }

  $scope.selectAssetsButtonPressed = function() {
    if (parseInt($scope.maxSelection) === 1) {
      flag = true;
    }
    $rootScope.datapointsSelected = [];

    let modalInstance = $uibModal.open({
      animation: true,
      template: require('../../../../components/assetpicker/asset.multi.picker.html'),
      controller: 'AssetMultiPickerController',
      size: 'lg',
      resolve: {
        singleSelect: flag,
        requiresSelection: false,
        prefilter: function() {
          return processPreFilter($scope.prefilter);
        },
        maxSelection: function() {
          return $scope.maxSelection;
        },
        selectedAssets: function() {
          return {...$scope.param._selected};
        },
        pickerSettings: () => ({canSelectAll: !flag})
      }
    });

    modalInstance.result.then(function(selectedAssets) {
      $scope.param._selected = selectedAssets.result;
      $rootScope.assetsSelected = selectedAssets.result;
      let assets = Object.keys(selectedAssets.result);

      for (let i = 0; i < assets.length; i++) {
        if (i === 0) {
          $scope.assetsSelected = assets[i];
        } else {
          $scope.assetsSelected = $scope.assetsSelected + ',' + assets[i];
        }
      }
    });
  };
}
